/**
### Why a Fallback is Needed
* **Safari Support:** Safari historically lacks native, default support for `window.requestIdleCallback` outside of experimental flags, causing undefined errors that can crash web apps.
* **Graceful Degradation:** Using a `setTimeout` shim ensures your low-priority tasks still execute reliably on Safari and older environments without breaking the script.
*/
export const rIC =
  window.requestIdleCallback ||
  function (cb)
  {
    return setTimeout(function ()
    {
      cb({
        didTimeout: false,
        timeRemaining: function ()
        {
          return Math.max(0, 50 - performance.now());
        },
      });
    }, 1);
  };
